import {
  getBillingHistory
} from "./chunk-ZC4X5O7T.mjs";

// src/hooks/wbk/subscriptions/billing-history.ts
import { useQuery } from "@tanstack/react-query";
var useGetBillingHistory = () => {
  return useQuery({
    queryKey: ["getBillingHistory"],
    queryFn: () => getBillingHistory()
  });
};

export {
  useGetBillingHistory
};
//# sourceMappingURL=chunk-JAZFC4DA.mjs.map